import { render } from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=template&id=2c74791e&scoped=true"
import script from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=script&lang=js"
export * from "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=script&lang=js"

import "./MarketingPreferencesAttributesSettingsHeader.vue?vue&type=style&index=0&id=2c74791e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c74791e"]])

export default __exports__